import { CheckedAddress } from '@sparkdotfi/common-universal'

import { ActionConfig, ActionContext } from '../../../logic/types'
import { getBorrowAllowanceQueryKey } from '../../approve-delegation/logic/query'
import { BorrowAction } from '../types'
import { poolAbi } from '@/config/abis/poolAbi'
import { InterestRate, SPARK_UI_REFERRAL_CODE } from '@/config/consts'
import { lendingPoolConfig, wethGatewayConfig } from '@/config/contracts-generated'
import { trackTransactionConfirmation } from '@/domain/analytics/cookie3'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { aaveDataLayerQueryKey } from '@/features/sparklend/common/data/market-info/aave-data-layer/query'

export function createBorrowActionConfig(action: BorrowAction, context: ActionContext): ActionConfig {
  const { account, chainId } = context
  const wethGatewayAddress = getContractAddress(wethGatewayConfig.address, chainId)
  const lendingPoolAddress = getContractAddress(lendingPoolConfig.address, chainId)
  const borrowTokenAddress = action.token.address
  const refCode = context.integratorRefCode === 190 ? context.integratorRefCode : SPARK_UI_REFERRAL_CODE

  return {
    getWriteConfig: () => {
      const borrowAmount = action.token.toBigInt(action.value)
      const interestRateMode = BigInt(InterestRate.Variable)

      if (borrowTokenAddress === CheckedAddress.EEEE()) {
        return ensureConfigTypes({
          abi: wethGatewayConfig.abi,
          address: wethGatewayAddress,
          functionName: 'borrowETH',
          args: [lendingPoolAddress, borrowAmount, interestRateMode, refCode],
        })
      }

      return ensureConfigTypes({
        abi: poolAbi,
        address: lendingPoolAddress,
        functionName: 'borrow',
        args: [borrowTokenAddress, borrowAmount, interestRateMode, refCode, account],
      })
    },

    invalidates: () => [
      getBalancesQueryKeyPrefix({ chainId, account }),
      aaveDataLayerQueryKey({ chainId, account }),
      getBorrowAllowanceQueryKey({
        fromUser: account,
        toUser: wethGatewayAddress,
        chainId,
        debtTokenAddress: borrowTokenAddress,
      }),
    ],

    onSuccessfulAction: () => {
      trackTransactionConfirmation({
        name: 'Borrow_Borrow_Confirmation',
        value: action.token.toUSD(action.value).toNumber(),
        isInSandbox: Boolean(context.isInSandbox),
      })
    },
  }
}
